/* file description */

import * as React from 'react';
import { Space, Swiper, Image, Card, Button, SearchBar, CheckList, Popup, Input, Cascader, TreeSelect } from 'antd-mobile';
import { useMemo, useState } from 'react';
import _ from 'lodash';
import styles from './index.module.less';
import { MobileInput } from '../../component/MobileInput';


const generateTree = (
  list,
  rootId,
  { idName = 'value', parentIdName = 'pId', childrenName = 'children' } = {},
) => {
  if (!Array.isArray(list)) {
    new Error('only Array');
    return list;
  }
  const objMap: any = {};
  const result = [];
  for (const item of list) {
    item.label = item.title;
    item.mobileValue = [item.value];

    const id = item[idName];
    const parentId = item[parentIdName];
    objMap[id] = !objMap[id] ? item : { ...item, ...objMap[id] };

    const treeItem = objMap[id];
    if (parentId === rootId) {
      result.push(treeItem);
    } else {
      // const fa = list.find((item) => item.value === parentId);
      // treeItem.mobileValue = [...fa.mobileValue, ...treeItem.mobileValue];
      if (!objMap[parentId]) {
        objMap[parentId] = {};
      }

      if (!objMap[parentId][childrenName]) {
        objMap[parentId][childrenName] = [];
      }
      objMap[parentId][childrenName].push(treeItem);
    }
  }
  return result;
};


export const MobileRecordTreeSelect = (
  {
    value,
    options,
    onChange,
    disabled,
  },
) => {
  const [cascaderVis, seCascaderVis] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [choiceValue, setChoiceValue] = useState('');

  const filteredItems = useMemo(() => {
    let dataList: any = [];
    if (searchText) {
      const opList = options.filter((item) => item.title.includes(searchText));
      dataList = _.cloneDeep(opList);
    } else {
      dataList = _.cloneDeep(options);
    }
    dataList.forEach((item: Record<string, any>) => {
      const result = dataList.find((op) => op.id === item.pId);
      if (!result) {
        item.pId = 'VRoot';
      }
    });
    const vNode = { id: 'vRoot', value: 'VRoot', pId: 0 };
    dataList.unshift(vNode);
    const result = generateTree(dataList, 0);
    return result[0]?.children || [];
  }, [options, searchText]);


  /**
   * 返回找到这条路径，组装成valueList
   * @param tree
   * @param value
   * @param path
   * @returns
   */
  const getPathById = (data, curKey, showKey) => {
    /** 存放搜索到的树节点到顶部节点的路径节点 */
    let result = [];
    const traverse = (curKey, path, data) => {
      // 树为空时，不执行函数
      if (data.length === 0) {
        return;
      }

      for (const item of data) {
        path.push(item[showKey]);
        if (item.value === curKey) {
          result = JSON.parse(JSON.stringify(path));
          return;
        }
        const children = Array.isArray(item.children) ? item.children : [];
        traverse(curKey, path, children);
        path.pop();
      }
    };
    traverse(curKey, [], data);
    return result;
  };


  return (
    <>
      <MobileInput
        value={getPathById(filteredItems, value, 'title').join('/')}
        onClick={() => seCascaderVis(true)}
        disabled={disabled}
      />

      <Popup
        visible={cascaderVis}
        onMaskClick={() => {
          seCascaderVis(false);
        }}
        destroyOnClose
      >
        <Space justify="between" block>
          <Button
            color="primary"
            fill="none"
            onClick={() => seCascaderVis(false)}
          >取消
          </Button>
          <Button
            color="primary"
            fill="none"
            onClick={() => {
              onChange(choiceValue);
              seCascaderVis(false);
            }}
          >确定
          </Button>
        </Space>
        <div className={styles.searchBarContainer}>
          <SearchBar
            placeholder="输入文字过滤选项"
            value={searchText}
            onChange={(v) => {
              setSearchText(v);
            }}
          />
        </div>
        <div className={styles.checkListContainer}>
          <TreeSelect
            defaultValue={getPathById(filteredItems, value, 'value') || []}
            options={filteredItems}
            onChange={(value, nodes) => {
              setChoiceValue(_.last(value) || '');
            }}
          />
        </div>
      </Popup>
    </>
  );
};
